import { useCallback, useState } from 'react';

import CalendarInput from 'components/generic/CalendarInput.component';
import CalendarRangedInput from 'components/generic/CalendarRangedInput.component';
import logger from 'utils/logger.util';

const L = logger('DatePanel'); // eslint-disable-line no-unused-vars

const STYLE_PANEL_GRID = Object.freeze({
  display: 'grid',
  gridTemplateColumns: '.5fr 1fr',
  gap: '2em',
  padding: '3em',
  gridAutoRows: 'minmax(100px, auto) ',
});

const STYLE_CODE = Object.freeze({
  fontFace: 'monospaced',
  background: '#EcEcEc',
  whiteSpace: 'nowrap',
});

const DatePanel = () => {
  const [bgn, setBgn] = useState();
  const [end, setEnd] = useState();

  const handleChange = useCallback((ev) => {
    L.debug('handleChange()', 'CalendarRangedInput ev:', ev);
    if (CalendarRangedInput.MODE.bgn === ev?.mode && 'select' === ev?.type) setBgn(ev?.iso);
    if (CalendarRangedInput.MODE.end === ev?.mode && 'select' === ev?.type) setEnd(ev?.iso);
  }, []);

  return (
    <div data-bem="DatePanel" style={STYLE_PANEL_GRID}>
      <p>
        <code style={STYLE_CODE}>{'<CalendarRangedInput >'}</code>&nbsp;:
      </p>

      <CalendarRangedInput bgn={bgn} end={end} onChange={handleChange} allowSameDay />

      <p>
        <code style={STYLE_CODE}>{'<CalendarInput>'}</code>&nbsp;:
      </p>
      <CalendarInput></CalendarInput>
    </div>
  );
};

export default DatePanel;
